
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/editor.global.scss.css.virtualfile';
        module.exports = {};